import { useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  hideMixingAutoProfile,
  showMixingAutoProfile,
} from "@/businesses/autoProfileBusiness";
import { DEVICE_STATE } from "@/constants/pcConstAppData";

function useShowMixingAutoProfile() {
  const dispatch = useDispatch();
  const currentPCState = useSelector(
    (state) => state.setupStore.currentPCState
  );
  const isMixingRef = useRef(currentPCState === DEVICE_STATE.MIXING);

  useEffect(() => {
    if (currentPCState === DEVICE_STATE.MIXING) {
      dispatch(showMixingAutoProfile());
      isMixingRef.current = true;
    }
    if (
      isMixingRef.current === true &&
      currentPCState !== DEVICE_STATE.MIXING
    ) {
      dispatch(hideMixingAutoProfile());
      isMixingRef.current = false;
    }

    return () => {
      // dispatch(hideMixingAutoProfile());
    };
  });

  return null;
}

export default useShowMixingAutoProfile;
